import { rem } from 'polished';
import { css, breakpoints } from '../../styles/theme';

export const StylesOV = css`
    @media (min-width: ${breakpoints.lg}px) {
        width: initial;
    }
    font-family: ${({ theme }) => theme.fonts.fontSecondary};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    color: ${({ theme }) => theme.colors.black};
    padding-left: ${rem('12px')};

    a {
        color: ${({ theme }) => theme.colors.black};
    }
    span,
    a {
        color: ${({ theme }) => theme.colors.black};
        text-transform: none;
        margin: 0 ${rem('3px')};

        :first-child {
            margin-left: 0;

            ::before {
                content: '';
                margin: 0;
            }
        }
        ::before {
            color: ${({ theme }) => theme.colors.black};
        }
    }
`;
